'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'diamond-exclamation';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e405';
var svgPathData = 'M256 319.1c-17.66 0-32 14.34-32 32s14.34 32 32 32s32-14.34 32-32S273.7 319.1 256 319.1zM232 151.1v112c0 13.25 10.75 24 24 24s24-10.75 24-24v-112c0-13.25-10.75-24-24-24S232 138.7 232 151.1zM497.7 222.6l-208.2-209.1c-19.01-18.02-50.05-18.02-68.06 0L14.27 222.6c-19.04 17.98-19.04 49.03 0 67.01l208.2 208.1c18.02 19.04 49.05 19.04 67.07 0l208.2-208.1C516.8 271.6 516.8 240.6 497.7 222.6zM256 463.4L48.64 256.1l206.2-208.1h.2891c.416 0 .7988 .0957 1.057 .1914c.127 .0332 .1914 .0645 .2559 .0957l206.9 207.8L256 463.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;